function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "noun-flowchart-3282990",
  transform: "translate(-131.243 -26.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3996",
  "data-name": "Path 3996",
  d: "M150.123,210h-8.856a1.93,1.93,0,0,0-1.931,1.931v2.116H133.3a2.058,2.058,0,0,0-2.058,2.058v9.179a2.058,2.058,0,0,0,2.058,2.058h2.971l-1.364,1.364a.589.589,0,0,0,0,.821.624.624,0,0,0,.381.127.6.6,0,0,0,.4-.162l2.809-2.809-2.682-2.671a.576.576,0,0,0-.821.809l1.364,1.364H133.3a.9.9,0,0,1-.9-.9V216.1a.9.9,0,0,1,.9-.9h6.035v2.116a1.93,1.93,0,0,0,1.931,1.931h8.856a1.93,1.93,0,0,0,1.931-1.931v-5.387A1.93,1.93,0,0,0,150.122,210Zm.775,7.318a.775.775,0,0,1-.775.775h-8.856a.775.775,0,0,1-.775-.775v-5.387a.775.775,0,0,1,.775-.775h8.855a.775.775,0,0,1,.775.775Z",
  transform: "translate(0 -171.352)",
  fill: "#f37320"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3997",
  "data-name": "Path 3997",
  d: "M264.53,393.75h-8.856a1.93,1.93,0,0,0-1.931,1.931v5.388h0A1.93,1.93,0,0,0,255.674,403h8.855a1.93,1.93,0,0,0,1.931-1.931v-5.387a1.93,1.93,0,0,0-1.931-1.931Zm.775,7.318a.775.775,0,0,1-.775.775h-8.856a.775.775,0,0,1-.775-.775v-5.387a.775.775,0,0,1,.775-.775h8.855a.775.775,0,0,1,.775.775Z",
  transform: "translate(-114.131 -342.964)",
  fill: "#f37320"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3998",
  "data-name": "Path 3998",
  d: "M272.5,30.3h-6.035V28.181a1.93,1.93,0,0,0-1.931-1.931h-8.856a1.93,1.93,0,0,0-1.931,1.931v5.387a1.93,1.93,0,0,0,1.931,1.931h8.856a1.93,1.93,0,0,0,1.931-1.931V31.453H272.5a.9.9,0,0,1,.9.9v9.179a.9.9,0,0,1-.9.9h-3.064l1.364-1.364a.576.576,0,0,0-.821-.809l-2.717,2.751,2.809,2.809h0a.6.6,0,0,0,.4.162.623.623,0,0,0,.416-.162.589.589,0,0,0,0-.821l-1.364-1.411H272.5a2.058,2.058,0,0,0,2.058-2.058V32.355A2.058,2.058,0,0,0,272.5,30.3Zm-7.191,3.272a.775.775,0,0,1-.775.775h-8.856a.775.775,0,0,1-.775-.775V28.181a.775.775,0,0,1,.775-.775h8.856a.775.775,0,0,1,.775.775Z",
  transform: "translate(-113.856)",
  fill: "#f37320"
}));

function SvgProcessFlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.455,
    height: 33.784,
    viewBox: "0 0 29.455 33.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessFlow);
export default __webpack_public_path__ + "static/media/processFlow.8da3e8256a118acc125fe4b25023e2cc.svg";
export { ForwardRef as ReactComponent };